module.exports = "landscape"